var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { getFontWeight } from '../../../abstracts/typography';
import { Link } from '../../Link';
var bannerTextButtonColorMap = {
    error: 'inverted',
    warn: 'secondary',
    success: 'secondary',
    "default": 'secondary',
    dark: 'inverted'
};
export var AlertBannerTextButtonElement = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: flex-end;\n  word-break: break-word;\n  font-weight: ", ";\n"], ["\n  align-self: flex-end;\n  word-break: break-word;\n  font-weight: ", ";\n"])), getFontWeight('heavy'));
export var AlertBannerTextButton = function (_a) {
    var alertBannerType = _a.alertBannerType, restProps = __rest(_a, ["alertBannerType"]);
    return (React.createElement(AlertBannerTextButtonElement, __assign({ color: bannerTextButtonColorMap[alertBannerType] }, restProps)));
};
var templateObject_1;
